// src/data/modules/mindease-modules-index.js
// The eight MindEase Vibe modules, plus the groupings the module pages render.
// These module files existed from the start but nothing imported them — the app
// was still reaching for the friendships-vibe index it was cloned from.
import mindeaseModule01 from "./mindease-vibe-module01";
import mindeaseModule02 from "./mindease-vibe-module02";
import mindeaseModule03 from "./mindease-vibe-module03";
import mindeaseModule04 from "./mindease-vibe-module04";
import mindeaseModule05 from "./mindease-vibe-module05";
import mindeaseModule06 from "./mindease-vibe-module06";
import mindeaseModule07 from "./mindease-vibe-module07";
import mindeaseModule08 from "./mindease-vibe-module08";

export const mindeaseModules = [
  mindeaseModule01,
  mindeaseModule02,
  mindeaseModule03,
  mindeaseModule04,
  mindeaseModule05,
  mindeaseModule06,
  mindeaseModule07,
  mindeaseModule08,
];

// Groupings follow each module's own `category` field: modules 1-2 explain what
// anxiety is doing, 3-5 are the core skills, 6-8 apply them to the situations
// that actually come up.
export const moduleCategories = {
  understanding: {
    title: "Understanding",
    description: "What anxiety is actually doing, and why",
    color: "blue",
    modules: [1, 2],
  },
  skills: {
    title: "Core Skills",
    description: "The techniques that calm it down",
    color: "green",
    modules: [3, 4, 5],
  },
  tools: {
    title: "Real-Life Tools",
    description: "Sleep, social situations, marks, and who to tell",
    color: "purple",
    modules: [6, 7, 8],
  },
};

export const programMetadata = {
  title: "MindEase Vibe",
  subtitle: "Turn the volume down on anxiety",
  description: "Science-based skills for understanding your anxiety and getting some say over it",
  targetAudience: "Young adults (13-25)",
  totalDuration: "4-6 hours of core content",
  outcomes: [
    "Understand why your brain treats ordinary things as emergencies",
    "Recognise what anxiety is doing in your body, as it happens",
    "Use breathing and grounding techniques that actually work",
    "Answer back to anxious thoughts instead of believing them",
    "Face avoided situations in steps you choose",
  ],
};

export default mindeaseModules;
